// extracted by css-extract-rspack-plugin
export default {"eGovButton":"SelectProcedureModal__eGovButton--iilAe"};